import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const PopoverCloseButtonContext = /*#__PURE__*/createContext(undefined);
export const PopoverCloseButtonProvider = ({
  closeButtonStyleOverrides,
  children
}) => {
  const value = useMemo(() => ({
    closeButtonStyleOverrides
  }), [closeButtonStyleOverrides]);
  return /*#__PURE__*/_jsx(PopoverCloseButtonContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `PopoverCloseButton` component.
 * Note: The context is only available when the `PopoverCloseButton` component is rendered as an ancestor.
 * @returns PopoverCloseButtonContext - The context for the `PopoverCloseButton` component.
 * @returns PopoverCloseButtonContext.closeButtonStyleOverrides - CSS overrides to apply to the `CloseButton` component.
 */
export const usePopoverCloseButtonContext = () => {
  const popoverCloseButtonContext = useContext(PopoverCloseButtonContext);
  return popoverCloseButtonContext;
};